if (!customElements.get('mjhome-stem-recipe')) {
  const selections = new Map();
  class MJHomeStemRecipe extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-recipe-config]').textContent);
      this.formId = this.dataset.formId;
      this.checkbox = this.querySelector('[data-recipe-checked]');
      this.total = this.querySelector('[data-recipe-total]');
      this.message = this.querySelector('[data-recipe-message]');
      this.rows = [...this.querySelectorAll('[data-stem-row]')];
      this.state = selections.get(this.formId) || { checked: false, quantities: {} };
      selections.set(this.formId, this.state);
      this.checkbox.checked = this.state.checked;
      this.rows.forEach(row => {
        const input = row.querySelector('[data-stem-quantity]');
        input.value = this.state.quantities[row.dataset.variantId] || input.value;
      });
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('change', () => {
        this.state.checked = this.checkbox.checked;
        this.rows.forEach(row => {
          this.state.quantities[row.dataset.variantId] = this.stemQuantity(row);
        });
        this.message.textContent = '';
        this.sync();
      }, { signal });
      document.addEventListener('input', event => {
        if (event.target !== this.checkbox) this.sync();
      }, { signal });
      document.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('submit', event => this.submit(event), { capture: true, signal });
      this.sync();
      this.hidden = false;
    }
    disconnectedCallback() { this.abort?.abort(); }
    stemQuantity(row) {
      return Math.min(20, Math.max(1, parseInt(row.querySelector('[data-stem-quantity]').value, 10) || 1));
    }
    mainQuantity() {
      const form = document.getElementById(this.formId);
      return Math.max(1, parseInt(form ? new FormData(form).get('quantity') : '1', 10) || 1);
    }
    variant() {
      const id = document.getElementById(this.formId)?.querySelector('[name="id"]')?.value;
      return this.config.mainVariants.find(variant => String(variant.id) === String(id));
    }
    stemsAvailable() {
      return this.rows.every(row => row.dataset.variantId && row.dataset.available === 'true' &&
        (row.dataset.tracked !== 'true' || Number(row.dataset.stock) >= this.stemQuantity(row) * this.mainQuantity()));
    }
    money(cents) {
      return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(cents / 100);
    }
    sync() {
      const available = this.stemsAvailable();
      this.checkbox.disabled = !available || this.busy === true;
      if (!available) this.state.checked = false;
      this.checkbox.checked = this.state.checked;
      const subtotal = this.rows.reduce((sum, row) => sum + Number(row.dataset.price) * this.stemQuantity(row), 0);
      const main = this.variant();
      const amount = this.state.checked && main ? (main.price + subtotal) * this.mainQuantity() : subtotal * this.mainQuantity();
      this.total.textContent = (this.state.checked ? this.config.text.selected : this.config.text.subtotal).replace('__TOTAL__', this.money(amount));
      if (!available && !this.busy) this.message.textContent = this.config.text.unavailable;
    }
    async submit(event) {
      if (event.target.getAttribute('id') !== this.formId || !this.checkbox.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.sync();
      const main = this.variant();
      if (!main?.available || !this.stemsAvailable() || !this.checkbox.checked) {
        this.message.textContent = this.config.text.unavailable;
        return;
      }
      if (!event.target.reportValidity() || !this.rows.every(row => row.querySelector('input').reportValidity())) return;
      const quantity = this.mainQuantity();
      const items = [{ id: main.id, quantity }, ...this.rows.map(row => ({ id: row.dataset.variantId, quantity: this.stemQuantity(row) * quantity }))];
      this.busy = true;
      this.message.textContent = this.config.text.adding;
      event.target.setAttribute('aria-busy', 'true');
      this.sync();
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.config.text.error);
        window.location.assign(this.config.cartUrl);
      } catch (error) {
        this.message.textContent = `${this.config.text.error} ${error.message === this.config.text.error ? '' : error.message}`.trim();
      } finally {
        this.busy = false;
        event.target.removeAttribute('aria-busy');
        this.sync();
      }
    }
  }
  customElements.define('mjhome-stem-recipe', MJHomeStemRecipe);
}
